module.exports = __webpack_public_path__ + "static/media/navy-pledge-1.0e6479aa.png";